import React from "react";
import { useNavigate } from "react-router-dom";
import { Notyf } from "notyf";
import "notyf/notyf.min.css";
import { useSelector } from "react-redux";
import { useConfig } from "../ConfigContext";
import HttpApis from "../services/HttpApis"; 

const useDetailsHook = () => {
  const navigate = useNavigate();
  const authtoken = useSelector((state) => state.authReducer.token);
  const isPremium = useSelector((state) => state.authReducer.user?.is_premium);
  const config = useConfig();
  const enableLogin = config?.enable_login;

  const notyf = new Notyf({ position: { x: "center", y: "center" } });

  const getRouteType = (apiType) => {
    if (!apiType) return "movie";

    const type = apiType.toString().toLowerCase().trim();

    if (type.includes("live-channel") || type.includes("channel")) return "live-channel";
    if (type.includes("live-stream") || type.includes("stream")) return "live-stream";
    if (type.includes("live")) return "live";
    if (type.includes("short")) return "short";
    if (type.includes("podcast")) return "podcast";
    if (type.includes("series")) return "series";
    if (type.includes("episode")) return "series";
    if (type.includes("movie")) return "movie";

    return "movie";
  };

  const handlePlayRoute = async (details) => {
    const { slug, type, position, content_type } = details || {};

    if (!slug) {
      console.error("❌ NO SLUG PROVIDED");
      notyf.error("Unable to play this content");
      return;
    }

    let finalSlug = slug;
    let routeType = getRouteType(content_type || type);
    if (routeType === "series" && !content_type?.toLowerCase().includes("episode")) {
      try {
        const response = await HttpApis.getSection(slug);
        const seriesData = response?.data?.data?.data || response?.data?.data;
        if (seriesData?.seasons && seriesData.seasons.length > 0) {
          const firstSeason = seriesData.seasons[0];
          if (firstSeason.episodes && firstSeason.episodes.length > 0) {
            const firstEpisode = firstSeason.episodes[0];
            finalSlug = firstEpisode.slug;
          }
        }
      } catch (error) {
        console.error("❌ Error fetching series:", error);
        notyf.error("Failed to load series");
        return;
      }
    }

    // If enable_login is false, allow playback without authentication
    if (enableLogin === false) {
      navigate(`/player/${routeType}/${finalSlug}`, {
        state: {
          fromMenu: false,
          startTime: position > 10 ? position : 0
        },
        replace: false
      });
      return;
    }

    // If enable_login is true, check authentication
    if (enableLogin === true && !authtoken) {
      console.warn("⚠️  Login required");
      notyf.error("Please login to watch");
      navigate("/login");
      return;
    }

    navigate(`/player/${routeType}/${finalSlug}`, {
      state: {
        fromMenu: false,
        startTime: position > 10 ? position : 0
      },
      replace: false
    });
  };

  const formatTime = (seconds = 0) => {
    if (isNaN(seconds) || seconds < 0) return "00:00:00";
    const hrs = Math.floor(seconds / 3600).toString().padStart(2, "0");
    const mins = Math.floor((seconds % 3600) / 60).toString().padStart(2, "0");
    const secs = Math.floor(seconds % 60).toString().padStart(2, "0");
    return `${hrs}:${mins}:${secs}`;
  };

  return { handlePlayRoute, formatTime };
};

export default useDetailsHook;